import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { CreateOrderRequest } from './api.types'
import useApi from './useApi'

const defaultRetryOptions = {
  retry: 3,
  retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 16000)
}

export const useCreateOrderMutation = ({ onSuccess, ...mutationOptions }: Omit<Parameters<typeof useMutation>[0], 'mutationFn'> = {}) => {
  const queryClient = useQueryClient()
  const { createOrder } = useApi()

  return useMutation({
    mutationFn: async (payload: CreateOrderRequest) => createOrder(payload),
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ['orders'] })

      if (onSuccess) {
        onSuccess(data, variables, context)
      }
    },
    ...mutationOptions,
    ...defaultRetryOptions
  })
}
